module.exports = __webpack_public_path__ + "img/superkid-logo.3da2749c.svg";